import React from 'react';
import { SelectTimezone, getTimezoneProps } from '@capaj/react-select-timezone';

import styles from './styles.module.less';

const TimeZoneSelect = (props) => {
  const [local, setLocal] = React.useState(props?.value);

  React.useEffect(() => {
    setLocal(props.value);
  }, [props.value])

  return (
    <div className={styles.time_zone_select}>
      <SelectTimezone
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: '27px',
            height: '.32rem',
            borderRadius: 4,
          }),
        }}
        className={styles.select_box}
        value={local}
        guess // this will fill the input with user's timezone guessed by moment. A "value" prop has always bigger priority than guessed TZ
        onChange={(val) => {
          const timezoneProps = getTimezoneProps(val);
          setLocal(val);
          props?.onChange && props?.onChange(val)
          props.setTimeZoneData({
            time: timezoneProps.time,
            locale: val
          })
        }}
      />
    </div>
  )
};

export default TimeZoneSelect;

